import React from 'react';
import {
  ProductCardBase,
  ProductCardTitle,
  ProductCardDescription,
  ProductCardBanner
} from './styles';

interface Props {
  bannerImage: string;
  title: JSX.Element;
  description: JSX.Element;
  cta: JSX.Element;
}

const ProductCard: React.FC<Props> = ({
  bannerImage,
  title,
  description,
  cta
}) => (
  <ProductCardBase>
    <ProductCardBanner img={bannerImage} />
    <main>
      <ProductCardTitle>{title}</ProductCardTitle>
      <ProductCardDescription>{description}</ProductCardDescription>
      {cta}
    </main>
  </ProductCardBase>
);

export default ProductCard;
